import { Filter } from "../Filter/Filter";
import { EventList } from "../EventList/EventList";
import type {
	AttachModeTarget,
	EventListTeamInfo,
	GameClipIntervalRequest,
	GameEventCommentProps,
	GameEventFilterUtilityProps,
	GamePageLazyResponse,
	GamePageResponse,
	GPGamePlayerResponse,
} from "../../../types";
import type { ReportEventErrorHandler } from "../../../report-error";
import styles from "./styles.module.scss";
import clsx from "clsx";
import { AttachModeSidebarView, useAttachStore } from "../../../attach-store";

interface AttachModeSidebarProps {
	target: AttachModeTarget;
	gameData: GamePageResponse;
	gameDataLazy?: GamePageLazyResponse;
	gameEventFilters?: GameEventFilterUtilityProps;
	teamInfo: EventListTeamInfo;
	clipsPermission?: boolean;
	eventsPermission?: boolean;
	reportEventErrorPermission?: boolean;
	onReportError?: ReportEventErrorHandler;
	handleCreateClip: (intervals: GameClipIntervalRequest[], name: string, description?: string) => void;
	eventCommentsPermission?: boolean;
	gameEventComment?: GameEventCommentProps;
	players?: GPGamePlayerResponse[];
}

export function AttachModeSidebar({
	gameData,
	gameDataLazy,
	gameEventFilters,
	teamInfo,
	clipsPermission,
	eventsPermission,
	reportEventErrorPermission,
	onReportError,
	handleCreateClip,
	eventCommentsPermission,
	gameEventComment,
	players,
}: AttachModeSidebarProps) {
	const { sidebarView } = useAttachStore();

	return (
		<div className={clsx(styles.sidebar, "attachMode-sidebar")}>
			{sidebarView === AttachModeSidebarView.EventList && (
				<EventList
					teamInfo={teamInfo}
					clipsPermission={clipsPermission}
					eventsPermission={eventsPermission}
					reportEventErrorPermission={reportEventErrorPermission}
					onReportError={onReportError}
					handleCreateClip={handleCreateClip}
					eventCommentsPermission={eventCommentsPermission}
					gameEventComment={gameEventComment}
					players={players}
				/>
			)}
			{sidebarView === AttachModeSidebarView.Filters && (
				<Filter gameData={gameData} gameDataLazy={gameDataLazy} gameEventFilters={gameEventFilters} />
			)}
		</div>
	);
}
